export var SigningType;
(function (SigningType) {
    SigningType["cosmWasm"] = "cosmWasm";
    SigningType["injective"] = "injective";
})(SigningType || (SigningType = {}));
